/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { useCallback, useRef } from 'react';
import getMeta from '@jira/platform__utils-get-meta/src/utils/get-meta/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { getIsInJiraHoldoutData } from '@atlassian/holdout-utils/jira-holdout';
import type { ExperienceAttributes } from '../../common/types.tsx';
import { useExperienceContext } from '../../common/ui/use-experience-context/index.tsx';

export type Props = {
	experience: string;
	attributes?: ExperienceAttributes;
};

export const useExperienceAbort = ({
	experience,
	attributes,
}: Props): ((reason: string, extraAttributes?: ExperienceAttributes) => void) => {
	const experienceTracker = useExperienceContext();

	const self = useRef({
		name: experience,
		attributes,
		experienceTracker,
	});

	self.current.name = experience;
	self.current.attributes = attributes;
	self.current.experienceTracker = experienceTracker;

	return useCallback(
		(reason: string, extraAttributes: ExperienceAttributes = {}) => {
			const { current } = self;

			let shardAndRegionAttributes: ExperienceAttributes = {};
			shardAndRegionAttributes = {
				shard: getMeta('ajs-shard'),
				region: getMeta('ajs-region'),
			};
			let holdoutAttributes: ExperienceAttributes = {};
			if (fg('add_holdout_attribute_to_jira_experience_tracker')) {
				holdoutAttributes = {
					customHoldout: getIsInJiraHoldoutData().holdout,
				};
			}

			current.experienceTracker.abort({
				name: current.name,
				reason,
				attributes: {
					...current.attributes,
					...extraAttributes,
					...shardAndRegionAttributes,
					...holdoutAttributes,
				},
			});
		},
		// oxlint-disable-next-line eslint-plugin-react-hooks/exhaustive-deps
		[self],
	);
};
